import Vue from "vue";
// import "babel-polyfill"
import ElementUI from "element-ui";
import horizontalScroll from 'el-table-horizontal-scroll'
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import {ACM} from "@/lib/common/acm"
import Component from 'vue-class-component'
import vuexStore from "@/store/vuex-store";
import ElTable from '@/components/table/index'
import '@/components/table/index.scss'
import { vSliderShow } from '@/views/ai-builder-component/plugins/directive'


Component.registerHooks([
 'beforeRouteEnter',
 'beforeRouteLeave',
 'beforeRouteUpdate'
])
ACM.updateConfigFile("company_config")
/* eslint-disable */

// let sensorsUrl = process.env.NODE_ENV === "production" ? "https://sensorsdata.hina.com:8106/sa?project=production" : "http://sensorsdata.hina.com:8126/sa?project=default"
// sensors.init({
//   server_url: sensorsUrl,
//   is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
//   use_client_time: true,
//   send_type: "beacon",
//   heatmap: {
//     //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
//     clickmap: "default",
//     //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
//     scroll_notice_map: "not_collect"
//   }
// });
// sensors.quick("autoTrack"); //用于采集 $pageview 事件



Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(horizontalScroll);
Vue.directive('sliderShow', vSliderShow)
Vue.component('ElTable', ElTable)
Vue.prototype.$P=vuexStore.P;

 //标签图标替换
//  const link: any =
//  document.querySelector("link[rel*='icon']") ||
//  document.createElement("link");
// link.type = "image/x-icon";
// link.rel = "shortcut icon";
// link.href =
//  "https://oss.hina.com/app/hina/2021/11/03/6bb1c963dad980e643785cb178e6307e.png";
// document.getElementsByTagName("head")[0].appendChild(link);


export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
